import {Accessor, Component, createEffect, createSignal, For, Setter, Show} from 'solid-js';

type RadioButtonProps = {
    name: string;
    value: string;
    text?: string;
    field: [Accessor<string>, Setter<string>];
};
export const RadioButton: Component<RadioButtonProps> = (props) =>
<label class="radio-inline">
    <input type="radio" name={props.name} checked={props.field[0]() == props.value} onChange={() => props.field[1](props.value)} /> <i></i> <span style="position: relative; top: 6px;">{(props.text || props.value)}</span>
</label>;

export const makeAccessor = (list: any) => createSignal<any[]>(list)[0];

type Theme = "light"|"dark";
type PageListProps = {
    pages: Accessor<number[]>;
    page: Accessor<number>;
    theme?: Theme;
    onClick: (page: number) => void;
};
export const PageList: Component<PageListProps> = (props) =>
{
    const [theme, setTheme] = createSignal<string>(props.theme || "light");
    return (<For each={props.pages()}>{(p: number) => <span classList={{ ["theme-" + theme()]: true }}><span class="alphabet-index" onClick={() => props.onClick(p)} classList={{ ["active-letter"]: p == props.page() }}>{p}</span></span>}</For>)
};

type AlphabeticalListProps = {
    letter: Accessor<string>;
    existingLetters?: Accessor<string[]>;
    onClick: (letter: string) => void;
};
export const AlphabeticalList: Component<AlphabeticalListProps> = (props) => {
    const createAlphabet = () => {
        const alpha = Array.from(Array(26)).map((e, i) => i + 65);
        const alphabet = alpha.map((x) => String.fromCharCode(x));
        return alphabet;
    };
    const letters = createAlphabet();
    const [existing, setExisting ] = createSignal<string[]>(letters);
    createEffect(() => {
        if (props.existingLetters()) setExisting(props.existingLetters());
    });
    console.log({ existing: existing(), letters: letters });
    return (
        <For each={letters}>{(l: string) =>
            <>
                <Show when={existing().indexOf(l) >= 0}>
                    <span class="alphabet-index" onClick={() => props.onClick(l)} classList={{ ["active-letter"]: l == props.letter() }}>{l}</span>
                </Show>
                <Show when={existing().indexOf(l) < 0}>
                    <span style="padding: 5px; color: #ccc;">{l}</span>
                </Show>
            </> 
        }</For>
    );
}


type SelectListProps = {
    class?: string;
    list: Accessor<any[]>;
    field: [Accessor<string>, Setter<string>];
};
export const SelectList: Component<SelectListProps> = (props) => 
<select class="form-control" value={props.field[0]()} onChange={(e) => props.field[1](e.currentTarget.value)}>
    <For each={props.list()}>{(item: any) =><option value={item.Value}>{item.Text}</option>}</For>
</select>;

type TextInputProps = {
    field: [Accessor<string>, Setter<string>];
};
export const TextInput : Component<TextInputProps> = (props) => <input type="text" class="form-control" value={props.field[0]()} onInput={(e) => props.field[1](e.currentTarget.value)} />;

type NumericalSelectListProps = {
    class?: string;
    list: Accessor<number[]>;
    field: [Accessor<number>, Setter<number>];
};
export const NumericalSelectList : Component<NumericalSelectListProps> = (props) => 
<select class="form-control" value={props.field[0]()} onChange={(e) => props.field[1](parseInt(e.currentTarget?.value))}>
    <For each={props.list()}>{(item: number) =><option value={item}>{item}</option>}</For>
</select>;